import {
  selectAuthFeatureFlagAgentInboxEnabledAt,
} from 'manager/selectors/auth'
import { MOBILE_FEATURE_INBOX, MOBILE_FEATURE_OPEN_URL, MOBILE_FEATURE_SUGGEST_TOUR, MOBILE_FEATURE_VOIP } from 'common/constants'
import { canAccessEmbeddedFeature, isEmbedded } from 'common/util/features'
import { createAction, handleActions } from 'redux-actions'
const LOAD = 'managerDashboard/LOAD'

export const load = createAction(LOAD)


export function getReferralFeatureFlags() {
  return (dispatch, getState) => {
    const canUseInbox = selectAuthFeatureFlagAgentInboxEnabledAt(getState()) && canAccessEmbeddedFeature(MOBILE_FEATURE_INBOX)
    const canUseVoip = selectAuthFeatureFlagAgentInboxEnabledAt(getState()) && canAccessEmbeddedFeature(MOBILE_FEATURE_VOIP)
    const suggestTourFeatureEnabled = canAccessEmbeddedFeature(MOBILE_FEATURE_SUGGEST_TOUR)
    const openUrlFeatureEnabled = canAccessEmbeddedFeature(MOBILE_FEATURE_OPEN_URL)
    return dispatch(load({
      canUseInbox,
      canUseVoip,
      suggestTourFeatureEnabled,
      openUrlFeatureEnabled,
    }))
  }
}

export function getEmbeddedFeatureFlags() {
  return async dispatch => {
    await dispatch(getReferralFeatureFlags())

    if (isEmbedded() && !window.feature_flags) {
      setTimeout(() => {
        if (!window.feature_flags) {
          dispatch(getEmbeddedFeatureFlags())
          return
        }
        dispatch(getReferralFeatureFlags())
      }, 50)
    }
  }
}

const initialState = {
  canUseInbox: false,
  canUseVoip: false,
  suggestTourFeatureEnabled: false,
  openUrlFeatureEnabled: false,
}

export default handleActions({
    [LOAD]: (state, { payload }) => ({ ...state, ...payload }),
}, initialState)
